export interface ApiError {
  error: string;
}

export interface DataPage {
  next?: string | null | undefined;
}

export const twentyFourHoursInMs = 1000 * 60 * 60 * 24;
